<template>
    <div class="main-content">
        <section class="text-center vertical-center">
            <div class="save-document-form" style="margin: auto;">
                <h2>You didn't Create any Projects yet</h2>
                <p>Create a Project to keep related Documents together, so they're always easy to find and share.</p>
                <router-link :to="{ name: 'Create Project' }" class="btn btn-primary mr-0 mt-3 mx-auto">Create a project
                </router-link>
            </div>
        </section>
    </div>
</template>


<script>
export default {
    name: "CreateIntro",
}
</script>

<style scoped>

</style>
